export const cnConfig = {
  taxOfficeName: 'STA',
  deliveryTaxOfficeQuestionTag: 'STA',
  searchPlaceholder: "Search taxpayers using names, Atlas ID or GTS ID...",
};
